module.exports = __webpack_public_path__ + "static/media/nathanmansur.e2f0041d.jpeg";